import { render, staticRenderFns } from "./r-item-offer-dialog.vue?vue&type=template&id=79b74026&scoped=true"
import script from "./r-item-offer-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-offer-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-offer-dialog.vue?vue&type=style&index=0&id=79b74026&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b74026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b74026')) {
      api.createRecord('79b74026', component.options)
    } else {
      api.reload('79b74026', component.options)
    }
    module.hot.accept("./r-item-offer-dialog.vue?vue&type=template&id=79b74026&scoped=true", function () {
      api.rerender('79b74026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-offer/r-item-offer-dialog.vue"
export default component.exports